<div class="body">
    <div class="appWrapper screen">
      <div class="appHeader">
        <span class="badge fs-14 rounded-pill p-2 bg-black back_button pointer" (click)="goBack()">
          <span class="text-theme-green align-middle"
              style="color:#ffffff !important; padding-right: 11px;line-height:20px;padding-left: 5px; font-size: 14px">
             <img src="./assets/images/back_left_arrow.png" width="16" height="7" alt="arrow"
                class="img-fluid" /> Back
            </span>
      </span>
          <div class="d-flex gap-3">
            <h5 class="fs-18 lh-1 fw-bold mb-0 text-black">
                <span>Dealer Details</span>
            </h5>
          </div>
    </div>
      <div class="appbody">
        <div class="appbody-wrap position-relative mb-3">
          <div class="card border-0 mb-3">
            <div class="card-body">
              <img
                src="{{ selectedstoredata.IMG_PATH }}"
                alt="store"
                class="img-fluid card-img mb-3"
              />
              <h4 class="h4 mb-1 font-weight-bold text-black">
                {{ selectedstoredata.DEALER_NAME }}
              </h4>
              <div
                class="d-flex align-items-center fw-semibold fs-14 text-dark mb-3"
              >
                <div class="flex-col">{{ selectedstoredata.FILLER_1 }}</div>
              </div>
              <div class="d-flex flex-wrap row-cols-2 fs-14">
                <div class="d-flex flex-column gap-2 mb-2">
                  <div class="flex-col flex-shrink-0 align-middle">
                    <img
                      src="./assets/images/call-green.svg"
                      alt="call"
                      class="img-fluid me-1 align-middle"
                    />
                    <span
                      class="text-theme-green font-weight-bold text-uppercase pl-2"
                      >Call</span
                    >
                  </div>
                  <div class="flex-col pt-1">{{ selectedstoredata.MOBILE }}</div>
                </div>
                <div class="d-flex flex-column gap-2 mb-2">
                  <div class="flex-col flex-shrink-0 align-middle">
                    <img
                      src="./assets/images/clock-green.svg"
                      alt="clock"
                      class="img-fluid me-1 align-middle"
                    />
                    <span
                      class="text-theme-green font-weight-bold text-uppercase pl-2"
                      >Time</span
                    >
                  </div>
                  <div class="flex-col pt-1">{{ selectedstoredata.TIMINGS }}</div>
                </div>
              </div>
              <div class="d-flex flex-column gap-2 mb-3 pb-1">
                <div class="flex-col flex-shrink-0 align-middle">
                  <img
                    src="./assets/images/map-pin-gr.svg"
                    alt="map-pin"
                    class="img-fluid me-1 align-middle"
                  />
                  <span
                    class="text-theme-green font-weight-bold text-uppercase pl-2"
                    >Address</span
                  >
                </div>
                <div class="flex-col pt-1">{{ selectedstoredata.ADDRESS }}</div>
              </div>
              <div class="d-flex gap-4 justify-content-center">
                <!-- <span class="call"><img src="./assets/images/call-circle.svg" alt="call"
                                      class="img-fluid" /></span> -->
                <a
                  class="mapPin pointer"
                  (click)="getDirection(selectedstoredata)"
                  ><img
                    src="./assets/images/map-pin-circle.svg"
                    alt="map-pin"
                    class="img-fluid"
                /></a>
                <!-- <span class="share"><img src="./assets/images/share.svg" alt="share"
                                      class="img-fluid " /></span> -->
              </div>
            </div>
          </div>
          <button [disabled]=disabledButton
            (click)="getPreApprovalLetter()"
            data-toggle="modal"
            class="btn btn-theme-green w-100 rounded-pill py-3 fw-medium ls-wide pointer"
            >Generate Pre Approval Letter</button
          >
          <button
            class="btn btn-faq mt-3"
            id="hiddenButton"
            style="margin-left: 40px; display: none"
            data-toggle="modal"
            data-target="#preAppLetter"
          ></button>
  
          <!-- data-toggle="modal" data-target="#preAppLetter" -->
        </div>
        <div
          class="modal fade faq-modal faq"
          id="preAppLetter"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content border-0">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLongTitle">
                    Pre Approval Letter
                  </h5>
  
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
  
                <div class="modal-body">
                  <ngx-extended-pdf-viewer
                    [showDownloadButton]="false"
                    [showOpenFileButton]="false"
                    [showRotateButton]="false"
                    [showZoomButtons]="false"
                    [base64Src]="imageBase64"
                    [textLayer]="true"
                    useBrowserLocale="true"
                    [showFindButton]="false"
                    [showSidebarButton]="false"
                    [showPrintButton]="false"
                    [showBookmarkButton]="false"
                    [showToolbar]="false"
                    [showSelectToolButton]="false"
                    [showSecondaryToolbarButton]="false"
                    mobileFriendlyZoom="150%"
                    height="80vh"
                    [zoom]="55"
                  ></ngx-extended-pdf-viewer>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="store-details">
          <h5 class="h5 font-weight-bold text-black mb-3">
            Other Store Near You
          </h5>
          <div class="overflow-auto" style="display: flex">
            <div class="col-4" *ngFor="let data of dealerData">
              <div class="card" style="border-radius: 0.375rem">
                <span
                  (click)="changeSelectedDealer(data)"
                  class="p-2 selected-theme pointer"
                >
                  <img
                    src="{{ data.IMG_PATH }}"
                    alt="store"
                    class="img-fluid card-img mb-2"
                  />
                  <h6 class="fs-13 font-weight-bold">{{ data.DEALER_NAME }}</h6>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <loader *ngIf="loader"></loader>
  